import React from 'react';
import css from './index.module.scss';
import EfModal from '@/components/UI/Modal';
import Button from '@/components/UI/Button';
import { getLang } from 'lowcomp/plugins/member/utils';
import getLocal from '@/app/utils/getLocal';
import { textLang } from 'lowcomp/plugins/member/common/textLang';
import { ModalCloseIcon } from '../icon';

interface NotAwardProps {
    desc?: string;
    open?: boolean;
    onCancel?: () => void;
}

const NotAward: React.FC<NotAwardProps> = ({ open, onCancel, desc }) => {
    const { locale } = getLocal();
    const t = getLang(textLang, locale);

    return (
        <EfModal centered className={css.efmodal} visible={open} zIndex={1200} onCancel={onCancel}>
            <div className="text-content">
                <p className="text-header">
                    <ModalCloseIcon onClick={onCancel} />
                </p>
                <p className="text">{desc}</p>

                <Button onClick={onCancel} className="m-btn">
                    {t('confirm_btn_text')}
                </Button>
            </div>
        </EfModal>
    );
};

export default NotAward;
